'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const makeRenderlessComponent = require('../utils/make-renderless-component.js');
const animationControls = require('../../animation/animation-controls.js');
const animationState = require('../../render/utils/animation-state.js');

var AnimationState = makeRenderlessComponent.makeRenderlessComponent(function (props) {
  var visualElement = props.visualElement,
    animate = props.animate;
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  visualElement.animationState || (visualElement.animationState = animationState.createAnimationState(visualElement));
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  if (animationControls.isAnimationControls(animate)) {
    React.useEffect(function () {
      return animate.subscribe(visualElement);
    }, [animate]);
  }
});
/**
 * @public
 */
var Animation = {
  key: "animation",
  shouldRender: function () {
    return true;
  },
  getComponent: function (_a) {
    var animate = _a.animate,
      whileHover = _a.whileHover,
      whileFocus = _a.whileFocus,
      whileTap = _a.whileTap,
      whileDrag = _a.whileDrag,
      exit = _a.exit,
      variants = _a.variants;
    return animate || whileHover || whileFocus || whileTap || whileDrag || exit || variants ? AnimationState : undefined;
  }
};

exports.Animation = Animation;
